import { render, staticRenderFns } from "./cancellationfail.vue?vue&type=template&id=b5c75a56&scoped=true"
import script from "./cancellationfail.vue?vue&type=script&lang=js"
export * from "./cancellationfail.vue?vue&type=script&lang=js"
import style0 from "./cancellationfail.vue?vue&type=style&index=0&id=b5c75a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c75a56",
  null
  
)

export default component.exports